import { $t } from '@/app-bootstrapping/SetUpInternationalization'

export function extractJobTitleWithFallback(row: {
  hires?: { data?: Array<{ latestContract?: { jobName?: string | null } | null }> } | null
}): string {
  const hire = row.hires?.data?.[0]
  return hire?.latestContract?.jobName || $t('No job assigned')
}

/**
 * Extracts hire ID with fallback for display
 * Works with any row that has hires with numbers
 */
export function extractHireIdWithFallback(row: {
  hires?: { data?: Array<{ number?: string | null }> } | null
}): string {
  const hire = row.hires?.data?.[0]
  if (!hire?.number) return '--'
  return `#${hire.number}`
}

/**
 * Extracts and formats city/state information from employment row
 * Works with any row that has worker address information
 */
export function extractCityDetailsFormatted(row: {
  worker?: { address?: { city?: string | null; state?: string | null } | null } | null
}): string {
  const address = row.worker?.address
  if (!address) return '-'

  const { city, state } = address
  if (!city && !state) return '-'

  if (state && city) {
    return `${city}, ${state}`
  }

  return city || state || '-'
}

/**
 * Extracts hiring managers from employment row
 * Works with any row that has hiring managers
 */
export function extractHiringManagers(row: {
  hiringManagers?: Array<{ id: string; name?: string | null }> | null
}): Array<{ id: string; name?: string | null }> {
  return row.hiringManagers || []
}

/**
 * Extracts the main hiring manager name
 * Works with any row that has hiring managers
 */
export function extractMainHiringManager(row: {
  hiringManagers?: Array<{ id: string; name?: string | null }> | null
}): string {
  const managers = extractHiringManagers(row)
  return managers[0]?.name || '-'
}
